/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API20838Item {
  
  /** 菜单id */
  resourceId?: string;
  
  /** 菜单名称 */
  resourceName?: string;
  
  /** 路径 */
  url?: string;
  
  /** 云桌面菜单标识 */
  nameEn?: string;
  
  /** 二级菜单数据 */
  childMenus?: API20838Item[];
  
};
    
  



export interface API20838Req {
  
  /** (String) */
  moduleId?: string;
    
};



export interface API20838Res {
  /** 模块id  */
  moduleId?: string;
  /** 模块名称  */
  moduleName?: string;
  /** 模块标识  */
  moduleNameEn?: string;
  /** 模块描述  */
  moduleRemark?: string;
  /** 模块图标icon  */
  moduleIcon?: string;
  /** 云分类id  */
  cloudCategoryId?: string;
  /** 云分类名称  */
  cloudCategoryName?: string;
  /** 序号  */
  sort?: number;
  /** 菜单资源数量  */
  resourceNum?: number;
  /** 是否展示  */
  isShow?: boolean;
  /** 菜单集合 ,DesktopResourceVO  */
  resourceList?: API20838Item[];
  /** 模块类型：DEFAULT ONLINE TRAILER  */
  moduleType?: string;
  /** 预告文案  */
  trailerText?: string;
  /** 产品负责人id  */
  productUserId?: string;
  /** 产品负责人名称  */
  productUserName?: string;
  /** 是否开放模块权限  */
  isPublish?: boolean;
  /** moduleShowType  */
  moduleShowType?: string;
  
};


// 20838 模块详情接口

export interface IUseGetAPI20838Return {
  /** 模块详情接口: 接口请求状态 */
  isAPI20838Loading: boolean;
  /** 模块详情接口: 接口请求返回数据 */
  dataAPI20838: API20838Res;
  /**  模块详情接口: 接口数据请求方法 */
  fetchAPI20838Data:  (inputs: API20838Req, config?: YWRequestConfig) => Promise<API20838Res>;
  /** 模块详情接口: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI20838 = ():IUseGetAPI20838Return => {
  let isMount = true;
  const [isAPI20838Loading, setIsAPI20838Loading] = useState(false);
  const [dataAPI20838, setDataAPI20838] = useState<API20838Res>({} as API20838Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/module/info`;

  const fetchAPI20838Data = async (inputs: API20838Req, config?: YWRequestConfig): Promise<API20838Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20838Req>) || {}) as API20838Req;
    
  
    if ( isMount ) {
      setIsAPI20838Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API20838Res>(`${basePath}/ywwl-admin/desktop/module/info?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI20838(res || {} as API20838Res);
        setIsAPI20838Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20838Loading(false);
      }
      return false as unknown as API20838Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20838Loading,
    dataAPI20838,
    fetchAPI20838Data,
    requestUrl,
  }
}

